var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 6a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0M3.75 22.5a6 6 0 0 1 6-6h4.5a6 6 0 0 1 6 6v.375c0 .623.502 1.125 1.125 1.125s1.125-.502 1.125-1.125V22.5a8.25 8.25 0 0 0-8.25-8.25h-4.5A8.25 8.25 0 0 0 1.5 22.5v.375c0 .623.502 1.125 1.125 1.125s1.125-.502 1.125-1.125z"
  })));
};
export default SvgUserIcon;